export default __webpack_public_path__ + "static/media/Vetfile-logo.59a8a891.svg";